import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import classes from './ContactUs.module.scss';
import {Link, withRouter} from "react-router-dom";
import Modal from "../UI/Modal/Modal";
import {toast, ToastContainer} from "react-toastify";
import Input from "../UI/Input/Input";
// Using reCAPTCHA v3: load grecaptcha dynamically and execute on submit
import Button from "../UI/Button/Button";
import {gaTracker} from "../../helper/Helper";
import {LANG_EN, LANG_ID, REGEX_EMAIL_PATTERN} from "../../constants";
import {FormattedMessage} from "react-intl";
import {Context} from "../../context/Wrapper";


const [paramActionOpenForm, paramLabelOpenForm, paramActionDetailOpenForm, paramLabelDetailOpenForm] = ['Contact Us Product Category', 'Contact Our Sales', 'Contact Us Product Detail', 'Contact Our Sales Detail'];
const [paramCategory, paramAction, paramLabel] = ['Button', 'Contact Us Product Category Submission', 'Send Contact Our Sales'];
const [paramDetailAction, paramDetailLabel] = ['Contact Us Product Detail Submission', 'Send Contact Our Sales Detail'];

const ContactUsHook = (props) => {
    const context = useContext(Context)
    const [modalToggle, setModalToggle] = useState(false);
    const [isReadyToSend, setIsReadyToSend] = useState(false);

    const [isVerified, setIsVerified] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [name, setName] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [email, setEmail] = useState()
    const [message, setMessage] = useState('')


    const [subjects, setSubjects] = useState({
        subject: 'PRODUCT_INFO'
        , subjectDesc: 'Product Info'
        , subjectDescId: 'Info Produk'
    })

    const [options] = useState([
        {displayId: 'Bicara dengan chef kami', displayValue: 'Talk with our chef', value: 'TALK_WITH'},
        {displayId: 'Hubungi Kami', displayValue: 'Contact Us', value: 'CONTACT_US'},
        {displayId: 'Info Produk', displayValue: 'Product Info', value: 'PRODUCT_INFO'},
    ])

    const [defaultMessage] = useState([
        {displayId: 'Saya mau tanya mengenai...', display: 'Can you help me with...'}
    ])

    const [state, setState] = useState({
        done: false,
        contact_us_page: []
        , message: ''
        , defaultSubjectMessage: undefined
        , isVerified: false
        , hasErrorname: true
        , hasErrorphone_number: true
        , hasErrorphone_numberFormat: true
        , hasErroremail: true
        , hasErroremailFormat: true
        , hasErrormessage: false
        , productCategorySelected: props.productCategorySelected
    });

    useEffect(() => {
        //====================================================================
        // console.log('USE EFFECT 1 Send Message');
        //====================================================================

        const ourRequest = axios.CancelToken.source();
        const doSend = async () => {
            try {
                const data = {
                    name,
                    phone_number: phoneNumber,
                    email,
                    subject: subjects.subjectDesc,
                    message: props.paramMessage.concat(' <br>: <strong>'.concat(message.concat('</strong>'))),
                    'g-recaptcha-response': recaptchaToken || '',
                };
                await axios.post('contact_us', data, {cancelToken: ourRequest.token});
                props.history.replace('/thanks-page');
            } catch (error) {
                // request failed
            }
        }
        if (isReadyToSend) {
            // console.log('subject.subjectDesc', subjects.subjectDesc);
            // console.log('isReadyToSend');
            doSend();
        }
        //eslint-disable-next-line
    }, [isReadyToSend, modalToggle])

    const onChangeHandler = (event) => {
        const pattern = new RegExp(/[^\d]/g);
        const fieldName = event.target.name;
        if (fieldName === 'name') {
            setName(event.target.value)
            if (event.target.value.trim().length < 1) {
                setState({hasErrorname: true});
            } else if (event.target.value.length > 0) {
                setState({hasErrorname: false});
            }
        }
        if (fieldName === 'phone_number') {
            setPhoneNumber(event.target.value)
            if (event.target.value.trim().length < 1) {
                setState({hasErrorphone_number: true, hasErrorphone_numberFormat: false});
            } else if (event.target.value.length > 0) {
                if (pattern.test(event.target.value)) {
                    setState({hasErrorphone_number: false, hasErrorphone_numberFormat: true});
                } else {
                    setState({hasErrorphone_number: false, hasErrorphone_numberFormat: false});
                }
            }
        }
        if (fieldName === 'message') {
            setMessage(event.target.value)
            if (event.target.value.trim().length < 1) {
                //set message as not required
                setState({hasErrormessage: false});
            } else if (event.target.value.length > 0) {
                setState({hasErrormessage: false});
            }
        }
        if (fieldName === 'subject') {
            const subjectSelected = {...options.find(x => x.value === event.target.value)}
            setState({subject: event.target.value, subjectDesc: context.locale === LANG_ID ? subjectSelected.displayId : subjectSelected.displayValue});
        }
    }
    // load recaptcha v3 script when component mounts
    useEffect(() => {
        const siteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY;
        if (siteKey && !document.querySelector('script[data-jbfs-recaptcha]')) {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
            script.async = true;
            script.defer = true;
            script.setAttribute('data-jbfs-recaptcha', 'true');
            document.body.appendChild(script);
        }
    }, []);

    const emailInputHandler = (event) => {
        const email = event.target.value;
        const pattern = new RegExp(REGEX_EMAIL_PATTERN);

        setEmail(email)

        if (event.target.value.trim().length < 1) {
            setState({...state, hasErroremail: true, hasErroremailFormat: false});
        } else if (event.target.value.length > 0) {
            setState({...state, hasErroremailFormat: false});
            if (pattern.test(email)) {
                setState({...state, isValidemail: true, hasErroremail: false, hasErroremailFormat: false});
            } else {
                setState({...state, isValidemail: false, hasErroremail: false, hasErroremailFormat: true});
            }
        }
    }

    const onSubmitHandler = () => {
        if (name === '') {
            setState({...state, hasErrorname: true});
            return;
        }
        if (phoneNumber === '') {
            setState({...state, hasErrorphone_number: true});
            return;
        }
        if (email === '') {
            setState({...state, hasErroremail: true});
            return;
        }
        if (message === '') {
            setState({...state, hasErrormessage: false});
            return;
        }

        const siteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY;
        if (!window.grecaptcha) {
            toast('Captcha not loaded, please try again later');
            return;
        }
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(siteKey, {action: 'contact_us'}).then(token => {
                setRecaptchaToken(token);
                setIsVerified(true);
                if (!state.hasErrorname &&
                    !state.hasErrorphone_number &&
                    !state.hasErrorphone_numberFormat &&
                    !state.hasErroremail &&
                    !state.hasErrormessage) {
                    toast("Submitting your message...");
                    setIsReadyToSend(true);
                    if (props.width === 18) {
                        gaTracker(paramCategory, paramAction, paramLabel);
                    } else {
                        gaTracker(paramCategory, paramDetailAction, paramDetailLabel);
                    }
                } else {
                    toast('Please, input required fields');
                }
            }).catch(() => toast('Captcha verification failed'));
        });
    }

    // const sendEmailHandler = async () => {
    //     // Alternative: post directly to backend contact endpoint
    //     // const data = new FormData();
    //     // data.append('name', name);
    //     // data.append('phone_number', phoneNumber);
    //     // data.append('email', email);
    //     // data.append('subject', subject.subjectDesc);
    //     // data.append('message', props.paramMessage + '.</br>Message: ' + message);
    //     // const apiUrl = process.env.REACT_APP_API_URL || '';
    //     // await axios.post(`${apiUrl}/contact_us`, data);
    // }

    const modalHandler = (e) => {
        e.preventDefault(); //i added this to prevent the default behavior
        setModalToggle(!modalToggle);
        setState({
            hasErrorname: false
            , hasErrorphone_number: false
            , hasErrorphone_numberFormat: false
            , hasErroremail: false
            , hasErroremailFormat: false
            , hasErrormessage: false
        })
        setSubjects({subject: 'PRODUCT_INFO', subjectDesc: 'Product Info', subjectDescId: "Info Produk"});
        setName('')
        setPhoneNumber('')
        setEmail('')
        // setMessage('')
        setMessage(context.locale === LANG_EN ? defaultMessage[0].display : defaultMessage[0].displayId)

        if (modalToggle === true) {
            if (props.width === 18) {
                //this for Catalog Page
                gaTracker(paramCategory, paramActionOpenForm, paramLabelOpenForm);
            } else {
                //this for Detail Product Page
                gaTracker(paramCategory, paramActionDetailOpenForm, paramLabelDetailOpenForm);
            }
        }
    }

    // v3 no explicit callback: token is retrieved on submit via grecaptcha.execute

    return (
        <>
            <div className={classes.ContactUs_row}>
                <Link onClick={modalHandler} to="#">
                    {/*<button style={{width: props.width + 'rem'}}>{props.buttonTitle}</button>*/}
                    <button>{props.buttonTitle}</button>
                </Link>
            </div>
            {modalToggle ?
                <Modal show={modalToggle}
                       customPosition={props.customPosition}
                       modalClosed={modalHandler}
                       title={<FormattedMessage id={"global.formcontactus.title"} defaultMessage={"CONTACT US"}/>}>
                    <div className={classes.FormAccess_container}>
                        <ToastContainer
                            position="top-center"
                            autoClose={4000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover/>
                        {state.hasErrorname && <div className={classes.FormValidation_input}><FormattedMessage id={"global.validation.required"} defaultMessage={"Field is required !"}/></div>}
                        <FormattedMessage id={"global.formcontactus.name"} defaultMessage={"Name"}>
                            {msg => (
                                <Input inputtype="input" type="text" name="name" label={msg}
                                       maxLength={30}
                                       onChange={(event) => onChangeHandler(event)}
                                       onFocus={(event) => onChangeHandler(event)}
                                       value={name}
                                />
                            )}
                        </FormattedMessage>
                        <div className={classes.Group_contact} style={{display: "flex"}}>
                            <div>
                                {state.hasErrorphone_number && <div className={classes.FormValidation_input}><FormattedMessage id={"global.validation.required"} defaultMessage={"Field is required !"}/></div>}
                                {state.hasErrorphone_numberFormat && <div className={classes.FormValidation_input}><FormattedMessage id={"global.validation.numberformat"} defaultMessage={"Number format doesn't match !"}/></div>}
                                <FormattedMessage id={"global.formcontactus.phonenumber"}>
                                    {msg => (
                                        <Input inputtype="input" type="text" name="phone_number" label={msg}
                                               onChange={(event) => onChangeHandler(event)}
                                               onFocus={(event) => onChangeHandler(event)}
                                               value={phoneNumber}
                                        />
                                    )}
                                </FormattedMessage>
                            </div>
                            <div>
                                {state.hasErroremail && <div className={classes.FormValidation_input}><FormattedMessage id={"global.validation.required"} defaultMessage={"Field is required !"}/></div>}
                                {state.hasErroremailFormat && <div className={classes.FormValidation_input}><FormattedMessage id={"global.validation.emailformat"} defaultMessage={"Email format doesn't match !"}/></div>}
                                <FormattedMessage id={"global.formcontactus.email"} defaultMessage={"Email"}>
                                    {msg => (
                                        <Input inputtype="input" type="text" name="email" label={msg}
                                               onChange={(event) => emailInputHandler(event)}
                                               onFocus={(event) => emailInputHandler(event)}
                                               value={email}
                                        />
                                    )}
                                </FormattedMessage>
                            </div>
                        </div>
                        <FormattedMessage id={"global.formcontactus.subject"} defaultMessage={"Subject"}>
                            {msg => (
                                <Input inputtype="input" type="text" name="subject" label={msg}
                                       readOnly
                                       mute={"true"}
                                       defaultValue={context.locale === LANG_ID ? subjects.subjectDescId : subjects.subjectDesc}/>
                            )}
                        </FormattedMessage>
                        <div>
                            <FormattedMessage id={"global.formcontactus.productcategory"}>
                                {msg => (
                                    <Input inputtype="textarea" type="text" name="product_category" label={msg}
                                           mute={"true"}
                                           defaultValue={props.paramMessage}
                                           readOnly
                                    />
                                )}
                            </FormattedMessage>
                        </div>
                        {state.hasErrormessage && <div className={classes.FormValidation_input}><FormattedMessage id={"global.validation.required"} defaultMessage={"Field is required !"}/></div>}
                        <FormattedMessage id={"global.formcontactus.message"} defaultMessage={"Message"}>
                            {msg => (
                                <Input inputtype="textarea"
                                       type="text" name="message" label={msg}
                                       onChange={(event) => onChangeHandler(event)}
                                       onFocus={(event) => onChangeHandler(event)}
                                       value={(message)}
                                />
                            )}
                        </FormattedMessage>
                        <div className={"jbfs-recaptcha"} />
                        <div>
                            <Button label={<FormattedMessage id={"global.formcontactus.button"} defaultMessage={"Send"}/>} width={30} onClick={() => onSubmitHandler()}/>
                        </div>
                    </div>
                </Modal> : null}
        </>
    )
}

export default withRouter(ContactUsHook)